import {
  conversationSelector,
  previousConversationSelector,
  useStore,
} from '@liveHelper/models/store'

import { useLocalStorage } from '@core/hooks/useLocalStorage'

/**
 * @returns True if the visitor has engaged with the conversation and an agent
 * is assigned to the conversation.
 */
export const useIsActiveConversation = () => {
  const [lastEngagedConversation] = useLocalStorage('lastEngagedConversation')
  const conversation = useStore(conversationSelector)

  return !!(
    conversation?.id === lastEngagedConversation && conversation?.agent_id
  )
}

/**
 * @returns True if the previous conversation is active
 */
export const useIsActivePreviousConversation = () => {
  const [lastEngagedConversation] = useLocalStorage('lastEngagedConversation')
  const previousConversation = useStore(previousConversationSelector)

  return !!(
    previousConversation?.id === lastEngagedConversation &&
    previousConversation?.agent_id
  )
}
